export class ViewModelResultadoEnvio {
    processado: number;
    sucesso: number;
    criticado: number;


}